"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  date?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalVideoNews(t0) {
  const $ = _c(41);
  const {
    title: t1,
    date: t2,
    imageSrc: t3,
    slug,
    imageMetadata
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: "\u0B9F\u0BBF20 \u0B89\u0BB2\u0B95\u0B95\u0BCD \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8 2023: \u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE, \u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BB0\u0BC8 \u0BAE\u0BBF\u0B95 \u0B85\u0BB0\u0BC1\u0B95\u0BBF\u0BB2\u0BCD \u0B89\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const title = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: "Web, 17 May 2023",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const date = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const imageSrc = t6;
  const titleValue = title?.value || "";
  const t7 = date?.value;
  let t8;
  if ($[6] !== t7) {
    t8 = getTimeAgo(t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const dateValue = t8;
  let t9;
  if ($[8] !== imageSrc?.value) {
    t9 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[8] = imageSrc?.value;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const imageSrcValue = t9;
  let t10;
  if ($[10] !== imageMetadata || $[11] !== imageSrc?.customClass || $[12] !== imageSrc?.hidden || $[13] !== imageSrcValue || $[14] !== titleValue) {
    t10 = !imageSrc?.hidden && <div className={`relative w-36 h-24 flex-shrink-0 overflow-hidden ${imageSrc?.customClass || ""}`}><Image src={imageSrcValue} alt={titleValue} fill={true} className="object-cover" style={getFocusPointStyle(imageMetadata)} loading="lazy" sizes="144px" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[10] = imageMetadata;
    $[11] = imageSrc?.customClass;
    $[12] = imageSrc?.hidden;
    $[13] = imageSrcValue;
    $[14] = titleValue;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== title?.customClass || $[17] !== title?.hidden || $[18] !== titleValue) {
    t11 = !title?.hidden && <h3 className={`text-14-tamil-700 text-#1B1B1B leading-[1.4] mb-2 ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[16] = title?.customClass;
    $[17] = title?.hidden;
    $[18] = titleValue;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== date?.customClass || $[21] !== date?.hidden || $[22] !== dateValue) {
    t12 = !date?.hidden && <span className={`text-10-tamil-500 text-#1B1B1B ${date?.customClass || ""}`}>{dateValue}</span>;
    $[20] = date?.customClass;
    $[21] = date?.hidden;
    $[22] = dateValue;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = slug ? `/${slug}` : undefined;
  let t14;
  if ($[24] !== imageSrcValue || $[25] !== slug || $[26] !== t13 || $[27] !== titleValue) {
    t14 = <div className="flex items-center gap-3"><MessageIcon id="message-icon-1" slug={slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={titleValue} thumbnailUrl={imageSrcValue} articleUrl={t13} /></div>;
    $[24] = imageSrcValue;
    $[25] = slug;
    $[26] = t13;
    $[27] = titleValue;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="flex items-center justify-between">{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t15) {
    t16 = <div className="flex-1 flex flex-col justify-between">{t11}{t15}</div>;
    $[32] = t11;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t10 || $[36] !== t16) {
    t17 = <article className="p-4 bg-light-green"><div className="flex gap-4">{t10}{t16}</div></article>;
    $[35] = t10;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const content = t17;
  if (slug) {
    const t18 = `/${slug}`;
    let t19;
    if ($[38] !== content || $[39] !== t18) {
      t19 = <Link href={t18} className="block hover:opacity-90 transition-opacity cursor-pointer">{content}</Link>;
      $[38] = content;
      $[39] = t18;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    return t19;
  }
  return content;
}